import React, { useEffect, useState } from 'react';
import { getCountry } from '@/utils/i18n';
import useStore from '@/store/useStore';
import { trackEventWithObject } from '@/utils/gaDataPush';

export default function Contact() {
  const { store, telCode, showroomName } = useStore(state => state.showroom);
  const { localGeToggle } = useStore(state => state.glLocation);
  const country = getCountry().code;
  const [phone, setPhone] = useState('');
  const US_PHONE = '800.691.0952';
  const isGlobalE = localGeToggle !== null && !localGeToggle;

  useEffect(() => {
    const localPhone = ['AU', 'CA'].includes(country) ? `${telCode}${store?.tel}` : store?.tel || US_PHONE;
    if (isGlobalE) {
      (window as any).getGlobalEPhoneNumber().then(phoneNumber => {
        setPhone(phoneNumber === US_PHONE ? localPhone : phoneNumber);
      });
    } else setPhone(localPhone);
  }, [country, isGlobalE, store?.tel, telCode]);

  const handleClick = () => {
    trackEventWithObject({
      event: 'header',
      general_event_category: 'Call Us',
      general_event_section: 'Main Icon',
      general_event_details: showroomName || 'Undefined',
    });
  };

  return (
    <a href={store?.contact_url || '/contact/'} id="header-telephone" onClick={handleClick}>
      {phone}
    </a>
  );
}
